import { render, staticRenderFns } from "./InfraInfo.vue?vue&type=template&id=f2f2c8b4&scoped=true&"
import script from "./InfraInfo.vue?vue&type=script&lang=js&"
export * from "./InfraInfo.vue?vue&type=script&lang=js&"
import style0 from "./InfraInfo.vue?vue&type=style&index=0&id=f2f2c8b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f2c8b4",
  null
  
)

export default component.exports